import React, { useEffect, useState } from "react";
import { VideoLoader, VideoPlayer } from "../components/UXHelper";
import { NavLink, useParams, useNavigate } from "react-router-dom";
import {
  ExtinctionVideoData,
  ExtinctionData
} from "../components/feactures/dataProvider_Testnet";
import { LoadRadiationTable } from "../components/feactures/dataFetcher";
import "./styles/home.css";
import { LayoutContainer } from "./layouts/layout_bi_columns";
import { JoinScreen } from "./RadiationAlliance";

export default function HomeDashboard({ userData, showLoader, closerLoader }) {
  const [radiationData, setRadiationData] = useState({
    status: false,
    statusCreator: false
  });

  const [nofity, setNotify] = useState({
    status: false,
    error: false,
    title: "",
    msg: "",
    txId: ""
  });

  const { id } = useParams();

  useEffect(() => {
    if (userData.isConnected) {
      getInfoRadiation(userData.username);
    }
    return () => {
      setRadiationData({
        status: false,
        statusCreator: false
      });
    };
  }, [userData.isConnected]);

  const getInfoRadiation = (account) => {
    LoadRadiationTable(account).then((x) => setRadiationData(x));
  };

  if (!userData.isConnected) {
    return (
      <div className="signIn_box">
        <h2 className="signIn-letter">You need to sign in before!</h2>
      </div>
    );
  }

  if (showLoader) {
    return (
      <div className="loader_animation">
        <VideoLoader
          url={ExtinctionVideoData.loader}
          url2={ExtinctionVideoData.loaderMobile}
          autoClose={closerLoader}
        />
      </div>
    );
  }

  if (!radiationData.status && id) {
    return (
      <JoinScreen
        userData={userData}
        setRdata={setRadiationData}
        refLink={true}
        referrer={id}
      />
    );
  }

  return (
    <LayoutContainer>
      <div className="home_container">
        <VideoPlayer
          url={"https://extinctionwars.com/assets/videos/home_16-9.webm"}
          url2={"https://extinctionwars.com/assets/videos/home_9-16.webm"}
        />
      </div>
    </LayoutContainer>
  );
}
